// var productCardMarkup = 
//   `<div class="swym-wishlist-grid">
// 		{{#products}} 
//     <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
// 		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
// 		<div class="swym-title swym-title-1">
// 			{{dt}}
// 		</div></button>
// 		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
// 			{{variantinfo}}
// 		</div>
// 		<div class="swym-product-price swym-text swym-text-1">
// 			<div class="swym-product-final-price swym-value">
// 				{{cu}}{{pr}}
// 			</div>
//         </div>
// 		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
// 			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to bag{{/isInCart}}
// 		</button>
//     </a> 
//        {{/products}}
// 	</div>`;

/* <svg aria-hidden="true" focusable="false" fill="none" width="12" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg> */
/* <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button product-card__quick-add-button"> */
/* <span class="hide--mobile">Add to cart</span> */
//  <svg aria-hidden="true" focusable="false" fill="none" width="12" class="hide--desktop" viewBox="0 0 12 12"><path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"/></svg>
// </button>


var productCardMarkup = 
  `<product-list class="product-list">
		{{#products}}	
			<product-card class="product-card reveal" data-product-id="{{empi}}">
				<div class="product-card__figure">
					<badge-list class="badge-list badge-list--vertical"></badge-list>
					<a href="{{du}}" class="product-card__media" data-instant>
						<img src="{{iu}}" class="product-card__image product-card__image--primary aspect-natural" loading="lazy" />
					</a>
					<a href="{{du}}" class="product-card__quick-add-button view-details">
						View Details
					</a>
				</div>
				<div class="product-card__info empty:hidden">
					<div class="v-stack justify-items-center gap-2">
						<div class="v-stack justify-items-center gap-1">
							<a href="{{iu}}" class="product-title h6" data-instant>{{dt}}</a>
							<price-list class="price-list">
								<sale-price class="h6">
									<span class="sr-only">Sale price</span>
									<span class="price-value" data-price="{{pr}}" data-currency="{{cu}}">{{cu}}{{pr}}</span>
								</sale-price>
							</price-list>
						</div>
						<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
							Remove
						</button>
					</div>
				</div>
			</product-card>
		{{/products}}
	</product-list>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderCustomFunc); /* Custom func */


let location_href = location.href, 
		swymListId = '',
		swymShareLink = '',
		submitData = {} ;


if(location_href.includes('?lid')) {
	swymListId = location_href.split('?lid=')[1];
	setTimeout(() => {
		document.querySelector('.wishlist-content-main').classList.add('shared-list');
	}, 150);
	window.SwymCallbacks.push(swymRenderSharedList);
}
else {
	window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
	window.SwymCallbacks.push(swymFetchList);
}

async function getProductById(id) {
	const handle = (await fetch(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`)
		.then(response => response.json())
		.then(response => response.resources.results.products.shift())).handle;
	return await fetch(`/products/${handle}.js`).then(response => response.json());
}

function swymFetchList(swat) {
	swat.fetchLists({
    callbackFn: function(lists) {
      swymListId = lists[0].lid;
      // swat.generateSharedListURL(swymListId, swymGenarateCopyLink);
    } 
  });
}

// function swymGenarateCopyLink(link, lid) {
//   swymShareLink = link;
// }

function swymRenderSharedList(swat) {
	let listConfig = {
    lid: swymListId
  }
  swat.fetchListDetails(listConfig, swymRenderSharedListContent);
}

function swymRenderSharedListContent(listDetails) {
	swymRenderWishlistContents(listDetails.items);
}

async function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
    swymRenderWishlistContents(products);
	});
}

async function swymRenderWishlistContents(products) {
	var mainCont = document.querySelector('.wishlist-content-main');
	var emptyCont = document.querySelector('.wishlist-content-empty');
	var headerIcon = document.querySelector('.header-nav--wishlist');
	var itemCount = document.querySelectorAll('.wishlist-item-count');

	if(products.length > 0) {
		mainCont.classList.remove('d-hidden');
		emptyCont.classList.add('d-hidden');
		headerIcon.classList.add('has-list');
	}
	else {
		mainCont.classList.add('d-hidden');
		emptyCont.classList.remove('d-hidden');
		headerIcon.classList.remove('has-list');
	}
	itemCount.forEach((count) => {
		count.innerText = products.length;
		count.classList.remove('d-hidden');
	})

	var wishlistContentsContainer = document.getElementById("wishlist-items-container");
	var formattedWishlistedProducts = products.map(function(p) {
		p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
		p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
		p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
		return p;
	});
	var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
		products: formattedWishlistedProducts
	});
	if(wishlistContentsContainer){
		wishlistContentsContainer.innerHTML = productCardsMarkup;
		document.querySelectorAll('.wishlist-items-container product-card').forEach(async (item) => {

			var el__price = item.querySelector('.price-list .price-value')
			var price = parseFloat(el__price.getAttribute('data-price'));
			var trail_part = price.toFixed(2).split('.')[1];
			var currency = el__price.getAttribute('data-currency');
			el__price.innerHTML = `${currency}${price.toLocaleString('en-US')}.${trail_part}`;

			var pid = item.getAttribute('data-product-id');
			var product = await getProductById(pid);
			if(product.tags.includes('Personalize') || product.tags.includes('Custom Personalize') || product.tags.includes('Bridal')) {
				item.querySelector('#swym-custom-add-toCartBtn').classList.add('d-hidden');
			}
		})
		attachClickListeners();
	} else{
		console.log("Container not found, Wishlist Page element not found");
	}
}

function onAddToCartClick(e) {
	e.preventDefault();

	var trigger = e.currentTarget.closest('button') || e.currentTarget;
	var productId = trigger.getAttribute("data-product-id");
	var variantId = trigger.getAttribute("data-variant-id");
	var du = trigger.getAttribute("data-product-url");
  // var state = trigger.getAttribute('data-state-cart');
	// e.target.innerHTML = "Adding..";

	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		// e.target.innerHTML = "Added to bag";
		trigger.setAttribute("data-state-cart", "swym-added");

		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true  //this code is for prestige theme, is to refresh the cart
	 	}))
		setTimeout(() => {
			document.querySelector('[aria-controls="cart-drawer"]').click();
		}, 300);
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to bag Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

// Open share wishlist popup.
const openModal = () => {
	var wishlistSharePopup = document.querySelector('.wishlist-share-popup');
	document.body.classList.add('lock');
	wishlistSharePopup.classList.add('open');
}

// Close share wishlist popup.
const closeModal = () => {
	var wishlistSharePopup = document.querySelector('.wishlist-share-popup');
	wishlistSharePopup.classList.remove('open');
	setTimeout(() => {
		document.body.classList.remove('lock');
	}, 200);
}

const emailValidate = (email) => {
	return String(email)
	.toLowerCase()
	.match(
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
}

const formValidate = () => {
	let selector = {
		blocks: '.form-block.required',
		emailInput: '.form-block #recipient-email',
		input: '.form-input'
	}
	var is_validated = true;
	document.querySelectorAll(selector.blocks).forEach((block) => {
		var input = block.querySelector(selector.input);
		if(input.value == '') {
			is_validated = false;
			block.classList.add('error-blank');
			block.classList.remove('error-invalid');
		}
		else {
			if(input.getAttribute('type') == 'email' && !emailValidate(input.value)) {
				is_validated = false;
				block.classList.remove('error-blank');
				block.classList.add('error-invalid');
			}
		}
		input.addEventListener('keydown', () => {
			setTimeout(() => {
				var f_block = input.closest('.form-block');
				if(input.value != '') {
					f_block.classList.remove('error-blank');
					if(input.getAttribute('type') == 'email') {
						if(emailValidate(input.value)) {
							f_block.classList.remove('error-invalid');
						}
						else {
							is_validated = false;
							f_block.classList.add('error-invalid');
						}
					}
				}
				else {
					f_block.classList.remove('error-invalid');
					f_block.classList.add('error-blank');
				}
			})
		})
	})

	if(is_validated) {
		document.querySelectorAll('.form-block').forEach((block) => {
			var input = block.querySelector(selector.input);
			submitData[input.getAttribute('name')] = input.value;
		})
		submitData['lid'] = swymListId;
		window.SwymCallbacks.push(shareListViaEmail);
	}
}

function onSubmitSuccess (response) {
	showNotification('.share-email');
	closeModal();
	console.log("Successfully sent the wishlist contents via Email", response)
}

function shareListViaEmail(swat) {
	swat.sendListViaEmail(submitData, onSubmitSuccess);
}

function getSwymShareLink () {
	var swymShareLink = `${location_href}?lid=${swymListId}`;
	if(location_href.includes('?lid=')) {
		swymShareLink = location_href
	}
	return swymShareLink;
}

function swymRenderCustomFunc () {

	let selector = {
		wishlistSharePopupTrigger: '.wishlist-share-popup-trigger',
		wishlistSharePopupClose: '.wishlist-share-popup .popup-close, .wishlist-share-popup .popup-bg',
		shareBtn: '.wishlist-share-btn' 
	}

	// Trigger popup open.
	var wishlistSharePopupTrigger = document.querySelector(selector.wishlistSharePopupTrigger);
	wishlistSharePopupTrigger.addEventListener('click', () => {
		openModal();
	})

	// Trigger popup close.
	var wishlistSharePopupClose = document.querySelectorAll(selector.wishlistSharePopupClose);
	wishlistSharePopupClose.forEach((closeEl) => {
		closeEl.addEventListener('click', () => {
			closeModal();
		})
	})

	document.querySelectorAll(selector.shareBtn).forEach((btn) => {
		btn.addEventListener('click', () => {
			var type = btn.getAttribute('data-type');
			if(type == 'email') {
				formValidate();
			}
			else {
  			navigator.clipboard.writeText(getSwymShareLink());
				closeModal();
				showNotification('.share-link');
			}
		})
	})
}

function showNotification(_class) {
	var notification = document.querySelector(`.swym-notification${_class}`);
	notification.classList.add('open');
	setTimeout(() => {
		notification.classList.remove('open');
	}, 3000);
}